import { call, select } from 'redux-saga/effects';
import Push from 'push.js';
import matchContact from '../../../utils/matchContact';
import formatPhoneNumber from '../../../utils/formatPhoneNumber';
import { selectConfig } from '../../../state/configs/configsSlice';

export default function* voicemailPush(voicemail) {
  const debug = localStorage.getItem('debugFlag') === 'true';

  // get the contact of who this is from
  let contact;
  if (voicemail.orig_from_uri) {
    // try to match by URI first (contains user@domain)
    contact = yield call(matchContact, voicemail.orig_from_uri);

    if (!contact && voicemail.orig_sub) {
      // fallback to matching by subscriber ID
      contact = yield call(matchContact, voicemail.orig_sub);
    }

    if (!contact) {
      // use provided name or format the subscriber ID as fallback
      contact = {
        first_name: voicemail.orig_from_name || formatPhoneNumber(voicemail.orig_sub),
      };
    }
  } else if (voicemail.orig_sub) {
    contact = yield call(matchContact, voicemail.orig_sub);

    if (!contact) {
      contact = {
        first_name: voicemail.orig_from_name || formatPhoneNumber(voicemail.orig_sub),
      };
    }
  } else {
    contact = { first_name: null };
  }

  const pushTitle = 'New Voicemail';
  const contactName = contact?.first_name || contact?.name || 'Unknown Caller';
  const pushBody = `New voicemail from ${contactName}`;

  const faviconURL = yield select((state) => selectConfig(state, 'faviconURL'));

  Push.create(pushTitle, {
    body: pushBody,
    icon: faviconURL,
    timeout: 10000,
    onClick() {
      if (debug) console.debug('clicked notification');
      window.focus();
      this.close();
    },
  }).catch(() => { });
}
